import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";
import katiaPortrait from "@/assets/katia-portrait.jpg";

const About = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isActive, setIsActive] = useState(false);

  const handleImageClick = () => {
    if (isMobile) {
      setIsActive(!isActive);
    }
  };

  return (
    <section id="about" className="py-section-lg bg-secondary/30">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <div className="relative">
            <div 
              className="aspect-[4/5] overflow-hidden"
              onClick={handleImageClick}
            >
              <img 
                src={katiaPortrait} 
                alt="Katia Dordevic, Lead Landscape Architect and founder of Katado Design" 
                className={`w-full h-full object-cover transition-all duration-700 ${
                  isActive ? 'grayscale-0' : 'grayscale hover:grayscale-0'
                }`}
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-border" />
          </div>

          {/* Content */}
          <div>
            <p className="text-label text-muted-foreground mb-4">{t('about.label')}</p>
            <h2 className="text-display-md font-serif text-foreground mb-8">{t('about.headline')}</h2>
            
            <div className="space-y-6 text-body text-muted-foreground">
              <p className="text-lg">
                {t('about.description1')}
              </p>
              
              <p>
                {t('about.description2')}
              </p>

              <p>
                {t('about.description3')}
              </p>
            </div>

            <div className="mt-10 pt-10 border-t border-border">
              <div className="flex flex-col sm:flex-row gap-8">
                <div>
                  <p className="text-4xl font-serif text-foreground">10+</p>
                  <p className="text-label text-muted-foreground mt-1">{t('about.yearsExperience')}</p>
                </div>
                <div>
                  <p className="text-4xl font-serif text-foreground">200+</p>
                  <p className="text-label text-muted-foreground mt-1">{t('about.projectsCompleted')}</p>
                </div>
                <div>
                  <p className="text-4xl font-serif text-foreground">48</p>
                  <p className="text-label text-muted-foreground mt-1">{t('about.statesServed')}</p>
                </div>
              </div>
            </div>

            <Button variant="hero-outline" size="lg" className="mt-10" asChild>
              <Link to="/contact">
                {t('about.scheduleConsultation')}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
